import { useEffect } from 'react';
import Alert from '@mui/material/Alert';

import useActiveAuth from 'hooks/useActiveAuth';

/**
 * Renders its children only when the partner user is signed in. If not, it
 * opens the partner login modal (via the shared 'partner:open-login' event)
 * and displays a small notice in place of the protected content. Direct URL
 * navigation to a protected partner route therefore can't bypass login.
 */
const PartnerProtected = ({ children }: { children: React.ReactElement }) => {
    const { isLoggedIn, openLogin } = useActiveAuth();

    useEffect(() => {
        if (!isLoggedIn) openLogin();
    }, [isLoggedIn]);

    if (!isLoggedIn) {
        return <Alert severity="info">Please sign in to access this page.</Alert>;
    }
    return children;
};

export default PartnerProtected;
